exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Icons__CheckMark__3fdBdy {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.Icons__CheckMark__3fdBdy path {\n  fill: #4a4a4a;\n}\n.Icons__CloseIcon__1j71Tv:hover path {\n  fill: #4a4a4a;\n}\n.dark .Icons__CheckMark__3fdBdy path {\n  fill: #fff;\n}\n.dark .Icons__icon__3vVFGy {\n  -webkit-filter: brightness(0) invert(1);\n          filter: brightness(0) invert(1);\n}\n", ""]);

// exports
exports.locals = {
	"CheckMark": "Icons__CheckMark__3fdBdy",
	"CloseIcon": "Icons__CloseIcon__1j71Tv",
	"icon": "Icons__icon__3vVFGy"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/src??ref--2-2!./node_modules/stylus-loader!./web_modules/trustar/icons/Icons.styl
// module id = 3480
// module chunks = 39